import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SimpleHeader from "./simple_header";
import MobileNavbar from "../../examples/Navbars/MobileNavbar";

export default function SimpleProfile() {
  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox mb={2} />
      <SimpleHeader />
    </DashboardLayout>
  );
}
